import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import "./BlimpMuiFormSection.scss";

const getClassName = (...items)=>{
    return items.filter(Boolean).join(" ");
};

export const BlimpMuiFormSection = (props)=>{
    const {
        bodyClassName="BlimpMuiForm-grid",
        children,
        className,
        icon:Icon,
        title
    } = props;

    return (
        <Box className={getClassName("BlimpMuiForm-section", className)}>
            <Stack className="BlimpMuiForm-sectionHead" direction="row">
                {Icon && <Icon className="BlimpMuiForm-sectionIcon" />}
                <Typography className="BlimpMuiForm-sectionTitle">{title}</Typography>
            </Stack>
            <Box className={bodyClassName}>
                {children}
            </Box>
        </Box>
    );
};
